import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsSidebarOpen } from "../slices/sidebarSlice";

const Sidebar = ({ openNav }) => {
  const isSidebarOpen = useSelector(selectIsSidebarOpen);
  const location = useLocation(); // To check active route

  // Navigation Items Configuration
  const navItems = [
    { path: "/dashboard", label: "Dashboard", icon: "fas fa-th-large" },
    { path: "/extension-live-calls", label: "Extension Live Call", icon: "fas fa-phone-volume" },
    { path: "/campaign-live-calls", label: "Campaigns Live Call", icon: "fas fa-headset" },
    { path: "/report-list", label: "Customer Detail", icon: "fas fa-address-book" },
    { path: "/User-Counts", label: "Users Counts", icon: "fas fa-users" },
    { path: "/purchase-number-list", label: "DID", icon: "fas fa-list-ol" },
    { path: "/manage-user", label: "Number Manage", icon: "fas fa-cogs" },
    { path: "/delete-users", label: "Deleted Number", icon: "fas fa-trash-alt" },
    { path: "/Customer-Report", label: "Customer Report", icon: "fas fa-chart-line" },
    { path: "/ip-white-list", label: "IP Settings", icon: "fas fa-network-wired" },
    { path: "/gatway", label: "Gateway", icon: "fas fa-server" },
    { path: "/extension-status", label: "Extensions Status", icon: "fas fa-signal" },
    { path: "/refulil-histry", label: "Refill History", icon: "fas fa-history" },
    { path: "/api", label: "API", icon: "fas fa-code" },
    { path: "/send-notification", label: "Send Notification", icon: "fas fa-paper-plane" },
    { path: "/twilio-number-fetch", label: "Twilio Number", icon: "fab fa-twitch" }, // Changed icon slightly
  ];

  // Helper to determine active state
  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Sidebar Container 
        - Fixed position
        - 64px from top (header height)
        - Transition for smooth toggle
        - Dark mode colors applied
      */}
      <aside
        className={`fixed left-0 top-[60px] bottom-0 z-40 w-64 bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 shadow-xl transition-transform duration-300 ease-in-out overflow-y-auto custom-scrollbar
        ${openNav || isSidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        `}
      >
        <div className="py-4 px-3">
          <ul className="space-y-1">
            {navItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  className={`flex items-center p-3 rounded-lg text-sm font-medium transition-all duration-200 group
                    ${
                      isActive(item.path)
                        ? "bg-blue-50 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400"
                        : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-blue-600 dark:hover:text-blue-400"
                    }
                  `}
                >
                  {/* Icon Container with fixed width for alignment */}
                  <div className={`w-8 flex justify-center text-lg ${
                     isActive(item.path) ? "text-blue-600 dark:text-blue-400" : "text-gray-400 group-hover:text-blue-500 dark:text-gray-500"
                  }`}>
                    <i className={item.icon} />
                  </div>
                  
                  <span className="ml-2 truncate">{item.label}</span>
                  
                  {/* Optional: Active Indicator Dot */}
                  {isActive(item.path) && (
                    <span className="ml-auto w-1.5 h-1.5 bg-blue-600 dark:bg-blue-400 rounded-full" />
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </aside>

      {/* Overlay for mobile (closes sidebar when clicking outside) */}
      {(openNav || isSidebarOpen) && (
        <div 
          className="lg:hidden fixed inset-0 z-30 bg-black/50 backdrop-blur-sm transition-opacity"
          onClick={() => {
            // Add your close handler logic here if passed from parent
            // e.g., props.onClose()
          }}
        />
      )}

      {/* Custom Scrollbar CSS */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 5px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #cbd5e1;
          border-radius: 20px;
        }
        .dark .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #4b5563;
        }
      `}</style>
    </>
  );
};

export default Sidebar;